module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.ffde4ef9.svg";